import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import _imports_0 from '@/assets/images/noData.png';
const _hoisted_1 = {
  style: {
    "padding": "100px 0",
    "text-align": "center"
  }
};
const _hoisted_2 = {
  class: "q-mt-lg"
};
export default {
  __name: 'index',
  props: {
    message: {
      type: String,
      default: ""
    }
  },
  setup(__props) {
    const props = __props;
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_cache[0] || (_cache[0] = _createElementVNode("div", null, [_createElementVNode("img", {
        src: _imports_0
      })], -1)), _createElementVNode("div", null, [_createElementVNode("span", _hoisted_2, _toDisplayString(props.message || _ctx.$t("common.noData")), 1)])]);
    };
  }
};